module.exports = __webpack_public_path__ + "img/visitor.9aedcb0c.png";